// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"cabb7530","787":"c363cc36"}[chunkId] + ".chunk.js";
};